import React from 'react';
import { useTranslation } from 'react-i18next';

function Map() {
  const { t } = useTranslation('contact');

  return (
    <div style={{ 
      width: '100%', 
      height: '100%',
      minHeight: '450px',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
    }}>
      <iframe
        title="OneArt Construction Location"
        src={t('map.embedUrl')}
        width="100%"
        height="100%"
        style={{ 
          border: 0,
          borderRadius: '12px',
          minHeight: '450px'
        }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}

export default Map;
